// @flow
import standartRequests from './standartRequests';


type Props<Params> = {
  id: string,
  requestPath: string,
  requestType?: $Values<typeof standartRequests>,
  requestParams?: Params,
  cbErrorTextCreate: (error: Error) => string,
  autoRequest?: boolean,
}

function pickDescription<Params>({
  id,
  requestPath,
  requestType = standartRequests.get,
  requestParams,
  cbErrorTextCreate,
  autoRequest,
}: Props<Params>) {
  const restKey: ('params' | 'data') = requestType === standartRequests.get ? 'params' : 'data';

  return {
    [id]: {
      path: requestPath,
      type: requestType,
      ...(requestParams
        ? {
          rest: {
            // $FlowFixMe
            [restKey]: requestParams,
          },
        }
        : {}
      ),
      cbErrorTextCreate,
      autoRequest: !!autoRequest,
    },
  };
}

export default pickDescription;
